import DOMPurify from 'dompurify';

export const stripHtml = (value) => {
  const fragment = DOMPurify.sanitize(String(value ?? ''), {
    RETURN_DOM_FRAGMENT: true,
    FORBID_TAGS: ['script', 'style'],
  });

  // Preserve structural boundaries before extracting text from the sanitized DOM.
  fragment
    .querySelectorAll(
      'address, article, aside, blockquote, dd, div, dl, dt, fieldset, figcaption, figure, footer, form, ' +
        'h1, h2, h3, h4, h5, h6, header, hr, li, main, nav, ol, p, pre, section, ' +
        'table, tbody, td, tfoot, th, thead, tr, ul',
    )
    .forEach((element) => {
      element.before('\n');
      element.after('\n');
    });
  fragment.querySelectorAll('br').forEach((element) => element.replaceWith('\n'));

  return fragment.textContent
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .join('\n');
};

class TextUtils {
  // Callers with a narrower HTML contract pass DOMPurify options such as ALLOWED_TAGS.
  static sanitizeHtml(html, options = {}) {
    return DOMPurify.sanitize(html || '', options);
  }

  // Normalize the decimal keyboard separator; reject the whole invalid edit, never strip it into another number.
  // Precision and clinical bounds remain with the form/API schemas, not this draft-input helper.
  static normalizeDecimal(value, previousValue = '') {
    const normalized = String(value ?? '').replace(',', '.');
    if (!/^\d*\.?\d*$/.test(normalized)) {
      return String(previousValue ?? '');
    }
    return normalized;
  }
}

export default TextUtils;
